import { frontendURL } from '../../../../helper/URLHelper';

const legacySettingsWorkflows = frontendURL(
  'accounts/:accountId/settings/workflows'
);
const legacyAutomationBase = frontendURL(
  'accounts/:accountId/settings/automation'
);

/**
 * Legacy automation URLs under Settings → redirect to account-scoped /workflows/*.
 */
export default {
  routes: [
    {
      path: legacyAutomationBase,
      redirect: to => ({
        name: 'automation_list',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: `${legacyAutomationBase}/list`,
      redirect: to => ({
        name: 'automation_list',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: `${legacyAutomationBase}/new`,
      redirect: to => ({
        name: 'automation_editor_new',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: `${legacyAutomationBase}/edit/:automationId`,
      redirect: to => ({
        name: 'automation_editor_edit',
        params: {
          accountId: to.params.accountId,
          automationId: to.params.automationId,
        },
      }),
    },
    {
      path: legacySettingsWorkflows,
      redirect: to => ({
        name: 'automation_list',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: `${legacySettingsWorkflows}/list`,
      redirect: to => ({
        name: 'automation_list',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: `${legacySettingsWorkflows}/new`,
      redirect: to => ({
        name: 'automation_editor_new',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: `${legacySettingsWorkflows}/edit/:automationId`,
      redirect: to => ({
        name: 'automation_editor_edit',
        params: {
          accountId: to.params.accountId,
          automationId: to.params.automationId,
        },
      }),
    },
  ],
};
